import store from '@/store/index';
export default function headerMeta({ to, next }) {
  store.dispatch('setHeaderTitle', (to.meta && to.meta.headerTitle) ? to.meta.headerTitle : '')
  return next();
}